module.exports = __webpack_public_path__ + "img/p5.46702e17.png";